import React, { useState, useEffect } from 'react';
import Storage from '~/providers/Storage';
import Request from '~/providers/Request';

const CurrentUser = React.createContext({
  user: null,
  setUser: () => null,
  loading: false,
  setLoading: () => false,
});

export function CurrentUserProvider({ children }) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);
  const [acceptedTermsAt, setAcceptedTermsAt] = useState(null);
  const [countryId, setCountryId] = useState(null);

  useEffect(() => {
    async function getUserProfile() {
      try {
        setLoading(true);
        const storagedUser = await Storage.getItem(Storage.userKey);
        setUser(storagedUser);

        const stored = await Storage.getItem(Storage.acceptedTermsAt);
        setAcceptedTermsAt(stored);

        if (storagedUser) {
          const response = await Request.get('/admin/user_profile');
          await Storage.setItem(Storage.userKey, response.data);
          setUser(response.data);
        }

        setLoading(false);
      } catch (e) {
        setLoading(false);
        console.log(e);
      }
    }
    getUserProfile();
  }, []);

  useEffect(() => {
    async function handleCountryIdChange() {
      const storedCountryId = await Storage.getItem(Storage.countryId);

      if (storedCountryId) {
        setCountryId(storedCountryId);
      }
    }

    handleCountryIdChange();
  }, [user]);

  async function setAcceptedTermsAtContext(value) {
    setAcceptedTermsAt(value);
    await Storage.setItem(Storage.acceptedTermsAt, value);
    await Request.post('/admin/users/accept_terms', {
      accepted_terms_at: new Date(),
    });
  }

  return (
    <CurrentUser.Provider
      value={{
        loading,
        user,
        setUser,
        acceptedTermsAt,
        setAcceptedTermsAtContext,
        countryId,
      }}
    >
      {children}
    </CurrentUser.Provider>
  );
}

export default CurrentUser;
